import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaExchangeAlt,
  FaClock,
  FaCalendarAlt,
  FaSyncAlt,
  FaList,
} from "react-icons/fa";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";

const formatDuration = (hours) => {
  if (!hours) return "N/A";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  const hourText = h > 0 ? `${h} hr${h > 1 ? "s" : ""}` : "";
  const minText = m > 0 ? `${m} min${m > 1 ? "s" : ""}` : "";
  return `${hourText}${hourText && minText ? " " : ""}${minText}` || "N/A";
};




    
const SwapListings = () => {
  const navigate = useNavigate();

  const [swaps, setSwaps] = useState([]);
  const [filters, setFilters] = useState({
    service: "Lawn Mowing",
    mode: "swaps",
    state: "",
    postcode: "",
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // Fetch swaps
  useEffect(() => {
    const fetchSwaps = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/swap-listings`);
        if (!res.ok) throw new Error(`Server returned ${res.status}`);

        const data = await res.json();

        setSwaps(data.listings || []);
      } catch (err) {
        console.error("❌ Failed to fetch swap-listings:", err);
      }
    };

    fetchSwaps();
}, []);

  const filteredSwaps = swaps.filter((swap) => {
    const matchState =
      !filters.state ||
      swap.swap_to_state?.toLowerCase() === filters.state.toLowerCase();

    const matchPostcode =
      !filters.postcode ||
      (swap.swap_to_postcode || "").toString().includes(filters.postcode);

    const matchSuburb =
      !filters.suburb ||
      swap.swap_to_suburb
        ?.toLowerCase()
        .includes(filters.suburb.toLowerCase());

    return matchState && matchPostcode && matchSuburb;
  });

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    position: "relative",
    border: "1px solid #ccc",
  };

  const viewButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const swapButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#0288d1",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
    marginBottom: "10px",
  };

const selectStyle = {
  width: "100%",
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "15px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: isMobile ? "0.9rem" : "1rem",
};

  return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#f4f7f9",
  }}
>
      {/* Sidebar */}
<aside
style={{
  width: isMobile ? "100%" : "250px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  padding: isMobile ? "4px 6px" : "20px",
  height: isMobile ? "auto" : "100vh",
  overflowY: isMobile ? "visible" : "auto",
  textAlign: "center",
}}
>
        <img
          src={logo}
          alt="Client Exchange Logo"
          style={{ width: "140px", margin: "0 auto 25px" }}
        />

      

       {/* FILTERS */}
<div style={{ marginTop: "20px", textAlign: "left" }}>

  {/* VIEW */}
<label style={{ fontWeight: "bold" }}>View:</label>
<select
  value={filters.mode}
  onChange={(e) => {
    const mode = e.target.value;
    setFilters({ ...filters, mode });

    if (mode === "listings") navigate("/listings");
    if (mode === "swaps") navigate("/swaps");
    if (mode === "rounds") navigate("/lawn-mowing/rounds");
  }}
  style={selectStyle}
>
  <option value="listings">Listings</option>
  <option value="swaps">Swaps</option>
  <option value="rounds">Rounds</option>
</select>

  {/* SERVICE */}
  <label style={{ fontWeight: "bold" }}>Service:</label>
  <select
    value={filters.service}
    onChange={(e) => {
      const service = e.target.value;
      setFilters({ ...filters, service });

      if (service === "Cleaning") navigate("/cleaning/swaps");
      if (service === "Pool Care") navigate("/poolcare/swaps");
      if (service === "Lawn Mowing") navigate("/swaps");
    }}
    style={selectStyle}
  >
    <option value="Lawn Mowing">Lawn Mowing</option>
    <option value="Cleaning">Cleaning</option>
    <option value="Pool Care">Pool Care</option>
  </select>

  {/* STATE */}
  <label style={{ fontWeight: "bold" }}>State:</label>
  <select
    value={filters.state}
    onChange={(e) =>
      setFilters({ ...filters, state: e.target.value })
    }
    style={selectStyle}
  >
    <option value="">All</option>
    {["VIC", "NSW", "QLD", "SA", "WA", "TAS", "NT", "ACT"].map((st) => (
      <option key={st} value={st}>
        {st}
      </option>
    ))}
  </select>

  {/* POSTCODE */}
  <label style={{ fontWeight: "bold" }}>Postcode:</label>
  <input
    type="text"
    value={filters.postcode}
    onChange={(e) =>
      setFilters({ ...filters, postcode: e.target.value })
    }
    placeholder="Enter postcode"
    style={selectStyle}
  />

{/* RESET */}
<button
  onClick={() => {
    setFilters({
      service: "Lawn Mowing",
      mode: "swaps",
      state: "",
      postcode: "",
    });

    navigate("/swaps");
  }}
  style={{
    width: "100%",
    padding: "12px",
    backgroundColor: "#d32f2f",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "10px",
  }}
>
  <FaSyncAlt /> Reset Filters
</button>

</div>

      </aside>

      {/* Main Content */}
<main
  style={{
    flex: 1,
    minWidth: 0,
    padding: isMobile ? "12px" : "30px 40px",
    overflowY: "auto",
    height: isMobile ? "auto" : "100vh",
  }}
>
  <div
    style={{
      textAlign: "center",
      fontSize: "1.5rem",
      fontWeight: "bold",
      marginBottom: "15px",
      color: "#2e7d32",
    }}
  >
          Available Swaps —{" "}
          <span style={{ color: "#333", fontWeight: "normal" }}>
            {filteredSwaps.length} Results
          </span>
        </div>

        <div
  style={{
    textAlign: "center",
    background: "#eef8f0",
    border: "1px solid #cfe8d3",
    borderRadius: "12px",
    padding: "14px 18px",
    margin: "0 auto 20px",
    maxWidth: "700px",
    color: "#1b5e20",
    fontWeight: "700",
  }}
>
  🚀 Soft Launch: Be among the first contractors to list on Client Exchange.
</div>

        {filteredSwaps.length === 0 ? (
          <p style={{ textAlign: "center" }}>No swap listings found.</p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "20px",
            }}
          >
            {filteredSwaps.map((swap) => {
              // Status Logic
              let badgeColor = "#0288d1";
              let badgeText = "Swap";
              let disabled = false;
              let buttonLabel = "Request Swap";

              if (swap.swap_status === "locked") {
                badgeColor = "#ffb300";
                badgeText = "Swap in Progress";
                disabled = true;
                buttonLabel = "Swap in Progress";
              }

              if (swap.swap_status === "handover") {
                badgeColor = "#fb8c00";
                badgeText = "Handover in Progress";
                disabled = true;
                buttonLabel = "Handover in Progress";
              }

              if (swap.swap_status === "completed") {
                badgeColor = "#9e9e9e";
                badgeText = "Completed";
                disabled = true;
                buttonLabel = "Completed";
              }

              return (
                <div key={swap.id} style={cardStyle}>
                  {/* Badge */}
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      backgroundColor: badgeColor,
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <FaExchangeAlt /> {badgeText}
                  </div>

                  <img
                    src={swap.image ? swap.image : "/images/Grass.jpg"}
                    alt="Swap"
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      opacity: swap.swap_status === "completed" ? 0.6 : 1,
                    }}
                  />

                  <div style={{ padding: "12px 15px" }}>
                    {/* Title */}
                    <h2
                      style={{
                        margin: "0 0 4px 0",
                        color: "#333",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      Swap – {swap.category || "Lawn Mowing"}
                      {swap.licence_verified ? (
                        <span
                          style={{
                            color: "#2e7d32",
                            fontSize: "0.85rem",
                            fontWeight: "600",
                            marginLeft: "6px",
                          }}
                        >
                          ✔ Verified
                        </span>
                      ) : null}
                    </h2>

                    <p
                      style={{
                        margin: "0 0 8px 0",
                        color: "#777",
                        fontSize: "0.8rem",
                      }}
                    >
                      ID: <strong>{swap.listingId}</strong>
                    </p>

                    {/* Location + Details */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        rowGap: "6px",
                        fontSize: "0.9rem",
                      }}
                    >
                      <div>
                        <FaMapMarkerAlt /> <strong>From:</strong>{" "}
                        {swap.swap_from_suburb} {swap.swap_from_postcode}
                      </div>

                      <div style={{ textAlign: "right" }}>
                        <strong>To:</strong> {swap.swap_to_suburb}{" "}
                        {swap.swap_to_postcode}
                      </div>

                      <div>
                        <FaClock /> {formatDuration(Number(swap.time))}
                      </div>

                      <div style={{ textAlign: "right" }}>
                        <FaCalendarAlt /> {swap.frequency}
                      </div>

                      <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
                        Cut Value: ${swap.cutValue}
                      </div>
                    </div>

                    {/* Buttons */}
                    <Link to={`/swap/${swap.id}`}>
                      <button style={viewButton}>View Details</button>
                    </Link>

                    
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </main>

    </div>
  );
};

export default SwapListings;
